import { IconName } from "@blueprintjs/core";

export const fieldTypesToIcons: Record<string, IconName> = {
  integer: "numerical",
  decimal: "numerical",
  range: "horizontal-distribution",
  text: "edit",
  select_one: "selection",
  select_one_from_file: "selection",
  select_multiple: "multi-select",
  select_multiple_from_file: "multi-select",
  rank: "sort-numerical",
  note: "lightbulb",
  geopoint: "map-marker",
  geotrace: "draw",
  geoshape: "geofence",
  date: "calendar",
  time: "time",
  datetime: "time",
  image: "media",
  audio: "headset",
  video: "video",
  file: "upload",
  barcode: "barcode",
  calculate: "function",
  acknowledge: "switch",
  hidden: "eye-off",
  "xml-external": "layout-hierarchy",
  start: "time",
  end: "time",
  today: "calendar",
  deviceid: "desktop",
  simserial: "sim-card",
  subscriberid: "id-number",
  phonenumber: "phone",
  username: "person",
  email: "envelope",
  audit: "shield",
  begin_group: "group-objects",
  begin_repeat: "repeat",
};
